import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyDetails.vue?vue&type=style&index=0&id=98071916&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98071916"]])

export default __exports__